var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapseBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#0066B0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12980_22664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2725 9.9993V21.4737C15.2725 21.778 15.1502 22.0698 14.9324 22.285C14.7147 22.5002 14.4195 22.6211 14.1116 22.6211L11.7898 22.6211C11.4819 22.6211 11.1867 22.5002 10.9689 22.285C10.7512 22.0698 10.6289 21.778 10.6289 21.4737V9.9993C10.6289 9.69498 10.7512 9.40313 10.9689 9.18794C11.1867 8.97275 11.4819 8.85186 11.7898 8.85186L14.1116 8.85186C14.4195 8.85186 14.7147 8.97275 14.9324 9.18794C15.1502 9.40313 15.2725 9.69498 15.2725 9.9993ZM11.7898 9.9993V21.4737L14.1116 21.4737V9.9993L11.7898 9.9993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3376 15.1628L20.8366 13.6791L21.6574 12.8679L24.5596 15.7365L21.6574 18.6051L20.8366 17.7938L22.3376 16.3102L18.7552 16.3102V22.6211L17.5943 22.6211V8.85186L18.7552 8.85186V15.1628L22.3376 15.1628Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12980_22664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.359,
    height: 18.5741,
    fill: "white",
    transform: "matrix(0 -1 -1 -4.37114e-08 26.8813 24.916)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseBlue);
export default __webpack_public_path__ + "static/media/CollapseBlue.0718b6f2143d26ec0359b4b9c1146458.svg";
export { ForwardRef as ReactComponent };